import { createClient, SupabaseClient } from '@supabase/supabase-js'

const SUPABASE_URL_KEY = 'dreamwright_supabase_url'
const SUPABASE_ANON_KEY_KEY = 'dreamwright_supabase_anon_key'

// Default Supabase config
const DEFAULT_SUPABASE_URL = 'https://wbyyvewxkhiuwavfqogi.supabase.co'
const DEFAULT_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndieXl2ZXd4a2hpdXdhdmZxb2dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU3NzE5MzUsImV4cCI6MjA4MTM0NzkzNX0.Ilez7mTjn9o0mE3vZhGOoL1zP_HS-UsgCEJj9wIDGTE'

// Safe localStorage access
function getFromStorage(key: string): string | null {
  if (typeof window === 'undefined') return null
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function setToStorage(key: string, value: string | null): void {
  if (typeof window === 'undefined') return
  try {
    if (value) {
      localStorage.setItem(key, value)
    } else {
      localStorage.removeItem(key)
    }
  } catch {
    // Ignore storage errors
  }
}

// Get config from localStorage or use defaults
export function getConfiguredSupabaseUrl(): string {
  return getFromStorage(SUPABASE_URL_KEY) || DEFAULT_SUPABASE_URL
}

export function getConfiguredSupabaseAnonKey(): string {
  return getFromStorage(SUPABASE_ANON_KEY_KEY) || DEFAULT_SUPABASE_ANON_KEY
}

export function setSupabaseUrl(url: string): void {
  setToStorage(SUPABASE_URL_KEY, url || null)
}

export function setSupabaseAnonKey(key: string): void {
  setToStorage(SUPABASE_ANON_KEY_KEY, key || null)
}

export function hasSupabaseConfig(): boolean {
  return !!(getConfiguredSupabaseUrl() && getConfiguredSupabaseAnonKey())
}

// Create and export the Supabase client
let supabaseInstance: SupabaseClient | null = null

function getSupabaseClient(): SupabaseClient {
  if (!supabaseInstance) {
    supabaseInstance = createClient(
      getConfiguredSupabaseUrl(),
      getConfiguredSupabaseAnonKey()
    )
  }
  return supabaseInstance
}

export function reinitializeSupabase(): void {
  supabaseInstance = createClient(
    getConfiguredSupabaseUrl(),
    getConfiguredSupabaseAnonKey()
  )
}

// Export a getter that always returns a valid client
export const supabase = {
  get auth() {
    return getSupabaseClient().auth
  },
  get from() {
    return getSupabaseClient().from.bind(getSupabaseClient())
  },
  get storage() {
    return getSupabaseClient().storage
  },
  get functions() {
    return getSupabaseClient().functions
  },
  get realtime() {
    return getSupabaseClient().realtime
  },
  get rpc() {
    return getSupabaseClient().rpc.bind(getSupabaseClient())
  },
}
